const observer: {
  handlers: Map<string, () => void>
  instance: IntersectionObserver | null
} = {
  handlers: new Map(),
  instance: new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return

        const element = entry.target
        const elementId = element.id

        const observerHandler = observer.handlers.get(elementId)

        observer.instance?.unobserve(element)
        observer.handlers.delete(elementId)

        if (!observerHandler) {
          return
        }

        observerHandler()
      })
    },
    {
      rootMargin: '100px 0px 100px 0px',
    }
  ),
}

export const visibleObserver = {
  observe(elementId: string, callback: () => void) {
    const element = document.getElementById(elementId)

    if (!element) {
      return
    }

    observer.handlers.set(elementId, callback)
    observer.instance?.observe(element)
  },
  unobserve(elementId: string) {
    const element = document.getElementById(elementId)

    observer.handlers.delete(elementId)

    if (!element) {
      return
    }

    observer.instance?.unobserve(element)
  },
}
